import React from 'react';
import './index.css';

interface TableLoadingComponentProps {
    numColumns: number;
}

const TableLoadingComponent: React.FC<TableLoadingComponentProps> = ({ numColumns }) => {
    const skeletonRows = Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="skeleton-row">
            {Array.from({ length: numColumns }).map((_, j) => (
                <div key={j} className={`skeleton-cell ${j === numColumns - 1 ? 'skeleton-color-action' : 'skeleton-color'}`} />
            ))}
        </div>
    ));

    return (
        <div className="skeleton-container">
            <div className="skeleton-header skeleton-color" />
            {skeletonRows}
        </div>
    );
}

export default TableLoadingComponent;